













import { Vue, Component } from "vue-property-decorator";
import ContractorForm from "@/components/contractors/ContractorForm.vue";
import ContractorFormV2 from "@/components/contractors/ContractorFormV2.vue";

@Component({
  components: { ContractorFormV2, ContractorForm }
})
export default class ContractorNew extends Vue {}
